import { V1Snapshot } from '../../api/v1Mqtt.api';
import { V1_CHANNEL_TRANSFORM, V1Channel } from './v1Transforms';

/**
 * Applied in this order because transforms read earlier channels: `info` carries the
 * pack type that the live and Spa Boy transforms scale by.
 */
const CHANNEL_ORDER: V1Channel[] = ['info', 'config', 'settings', 'network', 'spaboySettings', 'live', 'spaboyLive'];

export interface V1SnapshotSlices {
  live: Record<string, any>;
  settings: Record<string, any>;
  const: Record<string, any>;
}

/** A legacy database snapshot → the portal's V2-shaped redux slices. */
export function snapshotToSlices(snapshot: V1Snapshot): V1SnapshotSlices {
  const slices: V1SnapshotSlices = { live: {}, settings: {}, const: {} };

  CHANNEL_ORDER.forEach((channel) => {
    const patch = V1_CHANNEL_TRANSFORM[channel]?.(snapshot.channels[channel], slices);
    if (!patch) return;
    Object.assign(slices.live, patch.live);
    Object.assign(slices.settings, patch.settings);
    Object.assign(slices.const, patch.const);
  });

  Object.assign(slices.live, snapshot.extras.live);
  Object.assign(slices.settings, snapshot.extras.settings);

  return slices;
}
